var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9599 4.79961L8.80493 11.9546C8.09243 12.6671 5.9774 12.9971 5.5049 12.5246C5.0324 12.0521 5.3549 9.93707 6.0674 9.22457L13.2299 2.06209C13.4066 1.86938 13.6204 1.71448 13.8586 1.6067C14.0967 1.49893 14.3543 1.4405 14.6156 1.435C14.8769 1.4295 15.1367 1.47701 15.3792 1.57466C15.6217 1.67232 15.8419 1.81812 16.0265 2.00322C16.211 2.18832 16.3562 2.4089 16.4532 2.65164C16.5502 2.89439 16.5971 3.15427 16.5908 3.41561C16.5846 3.67694 16.5254 3.93434 16.4171 4.1722C16.3086 4.41006 16.1531 4.6235 15.9599 4.79961Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 3H4.5C3.70435 3 2.94133 3.31606 2.37872 3.87868C1.81612 4.44129 1.5 5.20435 1.5 6V13.5C1.5 14.2957 1.81612 15.0587 2.37872 15.6213C2.94133 16.1839 3.70435 16.5 4.5 16.5H12.75C14.4075 16.5 15 15.15 15 13.5V9.75",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b8299e8ee9b429b48f5ffce6b0caf88b.svg";
export { ForwardRef as ReactComponent };